import { FeatureAppConfig } from '../FeatureAppDefinition';
import { useFeatureAppEnvironment } from './use-feature-app-environment';


const FA_SERVICES_NAME: string = 'fa-services';

export function useFeatureAppConfig(): FeatureAppConfig {
  let { config, baseUrl, featureServices }: any = useFeatureAppEnvironment();

  const serviceConfig = featureServices['service-config-provider'];

  if (config && !config.faServicesUrl) {
    if (
      serviceConfig &&
      serviceConfig?.configs[FA_SERVICES_NAME] &&
      serviceConfig.configs[FA_SERVICES_NAME]?.urlOrigin
    ) {
      config = {
        ...config,
        faServicesUrl: serviceConfig.configs[FA_SERVICES_NAME]?.urlOrigin,
      };
    } else {
      throw new Error(
        "FeatureAppConfig Service Config: No 'fa-service' is configured",
      );
    }
  }

  if (config && !config.faHostServerUrl && baseUrl) {
    try {
      config = { ...config, faHostServerUrl: baseUrl || '' };
    } catch {
      // baseUrl is not a valid absolute URL (e.g. empty string on local), leave faHostServerUrl as-is
    }
  }

  return config || {};
}